import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AngularFireAuthModule } from 'angularfire2/auth';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingComponent } from './landing/landing.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { DynamicBannerComponent } from './dynamic-banner/dynamic-banner.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CarouselComponent } from './carousel/carousel.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CmsCampaignComponent } from './cms-campaign/cms-campaign.component';
import { CmsLoginComponent } from './cms-login/cms-login.component';
import { DatePipe } from '@angular/common';
import { CampaignFormComponent } from './campaign-form/campaign-form.component';
import { SignUpFlyoutComponent } from './sign-up-flyout/sign-up-flyout.component';
import { FlyoutDirective } from './sign-up-flyout/flyout.directive';
import { ScrollPositionComponent } from './scroll-position/scroll-position.component';
import { NavChangeDirective } from './directives/nav-change';
import { FooterComponent } from './footer/footer.component';
import { AboutComponent } from './about/about.component';
import { ProjectsComponent } from './projects/projects.component';
import { PeopleComponent } from './people/people.component';
import { ReviewsComponent } from './reviews/reviews.component';
import { ContactComponent } from './contact/contact.component';
import { ModalModule } from 'ngx-bootstrap';
import { SignUpQuoteComponent } from './sign-up-quote/sign-up-quote.component';

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    NavBarComponent,
    DynamicBannerComponent,
    CarouselComponent,
    CmsCampaignComponent,
    CmsLoginComponent,
    CampaignFormComponent,
    SignUpFlyoutComponent,
    FlyoutDirective,
    ScrollPositionComponent,
    NavChangeDirective,
    FooterComponent,
    AboutComponent,
    ProjectsComponent,
    PeopleComponent,
    ReviewsComponent,
    ContactComponent,
    SignUpQuoteComponent
  ],
  imports: [
    AngularFireAuthModule,
    BrowserModule,
    AppRoutingModule,
    CarouselModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    FormsModule
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
